import {
  CameraOptions,
  ImagePickerResponse,
  launchCamera,
} from 'react-native-image-picker';
import { requestCameraPermissions } from '../../utils/permissions';

const openCamera = async (
  options?: Partial<CameraOptions>
): Promise<ImagePickerResponse | undefined> => {
  if (await requestCameraPermissions()) {
    return await launchCamera({ ...options, mediaType: 'photo' });
  }
};

export default openCamera;
